"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import AuthGuardModal from './AuthGuardModal';
const PROTECTED_ROUTES = ['/dashboard', '/editor'];
export default function RouteGuard(t0) {
  const $ = _c(25);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  const {
    user,
    loading
  } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);
  const isProtected = _temp;
  let t1;
  let t2;
  if ($[0] !== loading || $[1] !== pathname || $[2] !== user) {
    t1 = () => {
      if (!loading && !user && isProtected(pathname)) {
        setPendingRoute(pathname);
        setShowModal(true);
      }
    };
    t2 = [pathname, user, loading];
    $[0] = loading;
    $[1] = pathname;
    $[2] = user;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== pendingRoute || $[6] !== user) {
    t3 = () => {
      if (user && pendingRoute) {
        setShowModal(false);
        setPendingRoute(null);
      }
    };
    t4 = [user, pendingRoute];
    $[5] = pendingRoute;
    $[6] = user;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== pathname) {
    t5 = () => {
      if (!isProtected(pathname)) {
        setShowModal(false);
        setPendingRoute(null);
      }
    };
    t6 = [pathname];
    $[9] = pathname;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== pathname || $[13] !== router || $[14] !== user) {
    t7 = () => {
      setShowModal(false);
      if (!user && isProtected(pathname)) {
        router.push("/");
      }
    };
    $[12] = pathname;
    $[13] = router;
    $[14] = user;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const handleClose = t7;
  if (!loading && !user && isProtected(pathname)) {
    let t8;
    if ($[16] !== handleClose || $[17] !== showModal) {
      t8 = <><AuthGuardModal isOpen={showModal} onClose={handleClose} /></>;
      $[16] = handleClose;
      $[17] = showModal;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  if (loading && isProtected(pathname)) {
    return null;
  }
  let t8;
  if ($[19] !== handleClose || $[20] !== showModal) {
    t8 = <AuthGuardModal isOpen={showModal} onClose={handleClose} />;
    $[19] = handleClose;
    $[20] = showModal;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== children || $[23] !== t8) {
    t9 = <>{t8}{children}</>;
    $[22] = children;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
function _temp(path) {
  return PROTECTED_ROUTES.some(route => path.startsWith(route));
}